module.exports = __webpack_public_path__ + "static/media/car-bus.4efdeac8.svg";